import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { removeSnackbarAction } from '../../actions/snackbarActions'
import Toast, { setToast } from '../babu/Toast'

const defaultDuration = 5000

export default function SnackBarContainer() {
  const dispatch = useDispatch()
  const ui = useSelector(state => state.ui)
  const { toast } = ui
  const prevToastRef = useRef('')

  useEffect(() => {
    if (toast.length > 0 && prevToastRef.current !== toast) {
      setToast(toast, { duration: defaultDuration })
      const timeoutID = setTimeout(() => {
        dispatch(removeSnackbarAction(-1))
      }, defaultDuration)
      return () => {
        if (timeoutID) {
          clearTimeout(timeoutID)
        }
      }
    }
    prevToastRef.current = toast
  }, [dispatch, toast])

  return <Toast />
}
